<template lang="pug">
.resultado-pago-wrapper
  .top-wrapper
    Navbar
    .container.flex-col.gap-1(v-if="otNumero")
      .flex-row.gap-2
        .label-ot Seguimiento OT:
        .label-ot.text-ot {{otNumero}}
    .container.resultado-pago-container(v-if="!loadingEstado")
        
      .contenedor

        //- Estado: Esperando confirmación
        .estado-esperando(v-if="estadoActual === 'PENDIENTE'")
          .spinner-border.text-primary.mb-4(role="status")
            span.sr-only Cargando...
          h1.h3.font-weight-bold.mb-4 Procesando Pago
          p.mb-4 Estamos confirmando tu pago. Esto puede tomar unos momentos...
          
          .alert.alert-info.text-left.mt-4(v-if="datosPago")
            p.mb-1
              strong Pago ID: 
              | {{ datosPago.pago_id }}
            p.mb-0.small Verificando estado con GetNet...
          
          .mt-3
            b-button(variant="outline-secondary" size="sm" @click="verificarEstado")
              | Verificar Estado Nuevamente

        //- Estado: Pago exitoso
        .estado-exitoso(v-else-if="estadoActual === 'EXITOSO'")
          .mb-4
            img(src="@/assets/img/pago_ok.png" style="width: 50%; height: 50%; display: block; margin: 0 auto;")
          .text-content
            h1.font-weight-bold.mb-4 {{ tituloPagoExitoso }}
            p.mb-4 {{ descripcionPagoExitoso }}
          
          .d-flex.flex-column.gap-3.align-items-center
            b-button(variant="primary" @click="volverASeguimiento")
              | Volver al inicio

        //- Estado: Pago fallido
        .estado-fallido(v-else-if="estadoActual === 'FALLIDO'")
          .mb-4
            img(src="@/assets/img/pago_fallido.png" style="width: 50%; height: 50%; display: block; margin: 0 auto;")
          .text-content
            h1.font-weight-bold.mb-4 ¡Lo sentimos, algo salió mal!
            p.mb-4 No pudimos procesar tu abono. Revisa tus datos o intenta nuevamente.

          .d-flex.align-items-center.justify-content-center.gap-3
            b-button(variant="warning" @click="reintentarPago")
              | Reintentar
            b-button.mt-0(variant="outline-dark" @click="volverASeguimiento")
              | Volver al inicio

        //- Estado: Error en generación de boleta
        .estado-error-boleta(v-else-if="estadoActual === 'ERROR_BOLETA'")
          .mb-4
            b-icon(icon="exclamation-triangle-fill" variant="warning" font-scale="5")
          h1.h3.font-weight-bold.mb-4.text-warning Pago Procesado - Error en Boleta
          p.mb-4 
            | Tu pago fue procesado exitosamente, pero hubo un problema al generar la boleta electrónica. 
            | Nuestro equipo ha sido notificado y se pondrá en contacto contigo.
          
          .alert.alert-warning.text-left.mt-4
            p.mb-2
              strong ¿Qué significa esto?
            ul.mb-0
              li Tu pago SÍ fue procesado correctamente
              li El abono se registró en nuestro sistema
              li Solo falta la generación de la boleta
              li Nos contactaremos contigo para enviártela
          
          b-button(variant="primary" size="lg" @click="volverASeguimiento" block)
            | Volver al Seguimiento

        //- Estado: Desconocido/Error
        .estado-error(v-else)
          .mb-4
            b-icon(icon="question-circle-fill" variant="secondary" font-scale="5")
          h1.h3.font-weight-bold.mb-4 Estado Desconocido
          p.mb-4 No pudimos determinar el estado de tu pago. Por favor, contacta con soporte.
          
          .d-flex.flex-column.gap-3
            b-button(variant="primary" size="lg" @click="verificarEstado")
              | Verificar Estado Nuevamente
            b-button(variant="outline-secondary" @click="volverASeguimiento")
              | Volver al Seguimiento

    //- Loader inicial
    .loader(v-else)
      b-spinner(label='Verificando estado del pago...' variant="primary" style="width: 3rem; height: 3rem;")
      p.mt-3 Verificando estado del pago...

  .bottom-wrapper
    .container
      hr.w-100.m-0
      span.footer-text © {{ currentYear }} Samtek | Servicio Técnico ASUS Autorizado en Chile.
</template>

<script>
import Navbar from '@/components/OT/ClientOT/Navbar/Navbar.vue'
import moment from 'moment'

export default {
  name: 'ResultadoPagoOT',

  components: {
    Navbar
  },

  data() {
    return {
      loadingEstado: true,
      estadoActual: null,
      datosPago: null,
      mensajeError: null,
      pagoId: null,
      otNumero: null,
      rutCliente: null,
      tipoPago: null // 'abono' o 'restante'
    }
  },

  computed: {
    currentYear() {
      return new Date().getFullYear()
    },
    
    tituloPagoExitoso() {
      if (this.tipoPago === 'restante') {
        return 'Monto Total Pagado'
      }
      return 'Abono Pagado'
    },
    
    descripcionPagoExitoso() {
      if (this.tipoPago === 'restante') {
        return (
          'Tu pago ha sido procesado exitosamente. El monto total de tu reparación ha sido ' +
          'pagado completamente. Recuerda visitar nuestro seguimiento para revisar el estado de tu reparación.'
        )
      }
      return (
        'Tu abono ha sido pagado correctamente, ahora podremos continuar con tu reparación. ' +
        'Recuerda visitar nuestro seguimiento para revisar el estado de tu reparación.'
      )
    }
  },

  async mounted() {
    // Obtener parámetros de la URL
    this.pagoId = this.$route.query.pago_id
    this.otNumero = this.$route.params.otId
    this.rutCliente = this.$route.params.rut
    this.tipoPago = this.$route.query.tipo_pago || 'abono' // 'abono' o 'restante'
    const estadoQuery = this.$route.query.estado
    const boletaQuery = this.$route.query.boleta
    const montoQuery = this.$route.query.monto

    // Verificar que tengamos los datos necesarios
    if (!this.pagoId && !estadoQuery) {
      this.$bvToast.toast('No se encontró información del pago', {
        title: 'Error',
        variant: 'danger',
        solid: true
      })
      this.volverASeguimiento()
      return
    }

    // Procesar estado del pago
    await this.procesarEstadoPago(estadoQuery, boletaQuery, montoQuery)
  },

  methods: {
    /**
     * Procesar y determinar el estado del pago
     */
    async procesarEstadoPago(estadoQuery, boletaQuery, montoQuery) {
      this.loadingEstado = true

      try {
        // Mapear el estado de la query
        switch (estadoQuery) {
          case 'EXITOSO':
          case 'APPROVED':
            this.estadoActual = 'EXITOSO'
            this.datosPago = {
              pago_id: this.pagoId,
              numero_boleta: boletaQuery,
              monto: montoQuery ? parseFloat(montoQuery) : null,
              fecha: new Date()
            }
            break

          case 'FALLIDO':
          case 'REJECTED':
          case 'FAILED':
          case 'CANCELLED':
            this.estadoActual = 'FALLIDO'
            this.mensajeError = 'El pago fue rechazado o cancelado'
            break

          case 'ERROR_BOLETA':
            this.estadoActual = 'ERROR_BOLETA'
            this.datosPago = {
              pago_id: this.pagoId,
              fecha: new Date()
            }
            break

          case 'PENDIENTE':
          case 'PENDING':
            this.estadoActual = 'PENDIENTE'
            this.datosPago = {
              pago_id: this.pagoId
            }
            // Verificar automáticamente después de un tiempo
            setTimeout(() => {
              this.verificarEstado()
            }, 5000)
            break

          default:
            this.estadoActual = 'DESCONOCIDO'
        }

        // Limpiar sessionStorage
        sessionStorage.removeItem('pagoOVEnProceso')

      } catch (error) {
        this.estadoActual = 'DESCONOCIDO'
        this.mensajeError = error.message
      } finally {
        this.loadingEstado = false
      }
    },

    /**
     * Verificar estado del pago manualmente
     */
    async verificarEstado() {
      if (!this.pagoId) {
        return
      }

      this.loadingEstado = true

      try {
        // Consultar el backend para obtener el estado actualizado (endpoint que devuelve JSON)
        const response = await this.$axios.get(
          `/api/oportunidadventa/verificar-estado-pago?pago_id=${this.pagoId}`
        )

        if (response.data && response.data.estado) {
          const { estado, boleta_token: boletaToken, numero_boleta: numeroBoleta, monto } = response.data
          
          // Actualizar la URL con el nuevo estado
          await this.$router.replace({
            query: {
              ...this.$route.query,
              estado,
              boleta: boletaToken || numeroBoleta,
              monto
            }
          })

          // Procesar el nuevo estado
          await this.procesarEstadoPago(
            estado,
            boletaToken || numeroBoleta,
            monto
          )
        }

      } catch (error) {
        this.$bvToast.toast('Error al verificar el estado del pago', {
          title: 'Error',
          variant: 'danger',
          solid: true
        })
      } finally {
        this.loadingEstado = false
      }
    },

    /**
     * Volver al seguimiento de la OT
     */
    volverASeguimiento() {
      if (this.otNumero && this.rutCliente) {
        this.$router.push(`/cliente/${this.otNumero}/rut/${this.rutCliente}`)
      } else {
        this.$router.push('/')
      }
    },

    /**
     * Reintentar el pago
     */
    reintentarPago() {
      // Limpiar datos del pago anterior
      sessionStorage.removeItem('pagoOVEnProceso')
      
      // Volver al seguimiento donde está el botón de pago
      this.volverASeguimiento()
      
      this.$bvToast.toast('Puedes intentar el pago nuevamente desde el seguimiento de tu OT', {
        title: 'Reintentar Pago',
        variant: 'info',
        solid: true,
        autoHideDelay: 5000
      })
    },

    /**
     * Formatear precio
     */
    formatearPrecio(precio) {
      if (!precio) return '0'
      return new Intl.NumberFormat('es-CL').format(precio)
    },

    /**
     * Formatear fecha
     */
    formatearFecha(fecha) {
      if (!fecha) return '-'
      return moment(fecha).format('DD/MM/YYYY HH:mm')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/colors.scss';

.resultado-pago-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f5f5f5;
}

.top-wrapper {
  flex: 1;
}


.label-ot {
  font-size: 28px;
  font-weight: 700;
  color: #525252;
}
.text-ot {
  color: $samtek-black;
}

.resultado-pago-container {
  padding: 2rem 1rem;
}

.max-w-md {
  max-width: 600px;
}

.mx-auto {
  margin-left: auto;
  margin-right: auto;
}

.gap-3 > * + * {
  margin-top: 1rem;
}

.loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  padding: 2rem;
}

.card {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.bottom-wrapper {
  margin-top: auto;
  padding: 1rem 0;
  background-color: #fff;
  border-top: 1px solid #dee2e6;
  
  .footer-text {
    display: block;
    text-align: center;
    color: #6c757d;
    font-size: 0.875rem;
  }
}

.contenedor {
  background-color: #fff;
  max-width: 950px;
  margin: 0 auto;
  text-align: center;
  padding: 2rem 1rem;
  border-radius: 2rem;
}

.text-content {

  padding: 0 4rem;
    
  h1 {
    margin-bottom: 1rem;
    color: $samtek-black;
  }
  p {
    margin-bottom: 1.5rem;
    font-size: 1.1rem;
  }
}
</style>
